import { render, staticRenderFns } from "./StartResumeHra.vue?vue&type=template&id=06d94976"
import script from "./StartResumeHra.vue?vue&type=script&lang=js"
export * from "./StartResumeHra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports